    <div class="fx_modal_container" appModalDrag>
        <!-- 标题栏 -->
        <div class="fx_modal_title">
            <div class="fx_le_title">
                    <i class="anticon anticon-credit-card"></i>
                    <span>{{title}}</span>
            </div>
                <!-- <dw-col dwSpan="8" dwpush="13">
                    <dw-input-group dwSuffixIcon="anticon anticon-search" style="line-height: 39px">
                        <input type="text" dw-input placeholder="请输入筛选条件" [(ngModel)]="_searchText" (keyup)="($event.which === 13)?search():0" #searchBox>
                    </dw-input-group>
                </dw-col> -->
                <div class="fx_ri_full">
                    <ul>
                        <li>
                            <ol class="fx_modal_icon-group">
                                <li>
                                    <i class="anticon anticon-arrows-alt fullBtn" (click)="fullModal(isParm)"
                                    [ngClass]="{'anticon-shrink': isFull}"></i>
                                </li>
                                <li>
                                    <i class="anticon anticon-close fx_modal_close_btn" (click)="fxCloseModal()"></i>
                                </li>
                            </ol>
                        </li>
                    </ul>
                </div>
        </div>
        <!-- <div dw-row class="fx-modal-content">-->
        <!--<dw-col dwSpan="15">-->
        <!--<button dw-button [dwType]="'default'" (click)="debug()">DEBUG</button>-->
        <!--</dw-col>-->
        <!--&lt;!&ndash;<dw-col dwSpan="9" [dwPush]="15">&ndash;&gt;-->
        <!--<dw-col dwSpan="9" >-->
        <!--<dw-input-group dwSuffixIcon="anticon anticon-search">-->
        <!--<input type="text" dw-input placeholder="请输入筛选条件" [(ngModel)]="_searchText" (keyup)="($event.which === 13)?search():0">-->
        <!--</dw-input-group>-->
        <!--</dw-col>-->
        <!--</div> -->
        <!-- 显示区域 -->
        <dw-row class="fx_modal_content" [style.height]="isHeight">
            <div dw-row dwType="flex" dwJustify="end">
                <dw-col dwSpan="24">
                    <span>{{'com-特征' | translate}}：{{dataInfo.model_no}}
                        {{dataInfo.model_name ? ('(' + dataInfo.model_name + ')') : ''}}</span>
                </dw-col>
            </div>

            <div class="fx_goods_ct_features" *ngFor="let chcar of characterTypeList;let key=index;">
                <span>{{chcar.char_type_n1}}</span>
                <ul>
                    <li *ngFor="let item of chcar.char_value_list;let valKey=index;"
                        [ngClass]="{'feature-select': item.selected, 'feature-disabled': item.disabled || !item.result.length}"
                        (click)="selectFeatrueAndFixing(key, valKey)">
                        {{item.cae003_n1}}</li>
                </ul>
            </div>
            <div *ngIf="!characterTypeList.length && isReady" class="fx-character-emtpy">
                <span>暂无数据~</span>                
            </div>
            <!-- <ag-grid-angular
                    #agGrid
                    style="width: 100%; height: 100%;"
                    id="myGrid"
                    [(rowData)]="_displyData"
                    class="ag-theme-balham"
                    [defaultColDef]="_defaultColDef"
                    [columnDefs]="_columnDefs"
                    [components]="_components"
                    [enableSorting]="false"
                    [pagination]="true"
                    [suppressPaginationPanel]="true"
                    [paginationPageSize]="_pageSize"
                    [rowSelection]="_rowSelection"
                    [rowMultiSelectWithClick]="true"
                    [editType]="false"
                    [enableFilter]="false"
                    [floatingFilter]="false"
                    [enableColResize]="true"
                    rowSelection="multiple"
                    defaultColDef = "{ width: 100 }"
                    (gridReady)="onGridReady($event)"
                    (selectionChanged) = "selectionChanged($event)"
                ></ag-grid-angular> -->
        </dw-row>

        <dw-row class="fx_modal_footer">
            <!-- <div dw-col [dwSpan]="18">
                <dw-pagination [dwPageIndex]="_pageNumber" [dwTotal]="_rowCount" dwShowSizeChanger dwShowQuickJumper [(dwPageSize)]="_pageSize" [dwSize]="'small'" (dwPageIndexChange)="onPageIndexChange($event)"
                            (dwPageSizeChange)="onPageSizeChange()"></dw-pagination>
            </div> -->
            <div dw-col [dwSpan]="24">
                <div dw-row dwType="flex" dwJustify="end">
                    <button dw-button [dwType]="'default'" (click)="onClickCancel()">取消</button>
                    <button dw-button [dwType]="'primary'" (click)="onClickOK()">确定</button>
                </div>
            </div>
        </dw-row>
    </div>

